// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
import { useTranslation } from "react-i18next";
import { Col, Row } from "antd";
import FormField from "../../../components/FormField";
import { NewsThemeFormProps } from "../../../types/NewsThemeTypes";
import { FIELD_LENGTH } from "../../../../utils/Constant";

const NewsThemeContactFormSection: React.FunctionComponent<NewsThemeFormProps> = (
  props: NewsThemeFormProps
) => {
  const { t } = useTranslation();

  const { editMode } = props;

  return (
    <>
      <Row>
        <Col xs={24} sm={12}>
          <FormField
            labelName={t("news_theme.contact.mail")}
            inputId="contactMail"
            emptyErrorMessage={t("global.empty_error_field")}
            readOnly={!editMode}
            type="email"
            maxLength={FIELD_LENGTH.MAIL}
          />
        </Col>
        <Col xs={24} sm={12}>
          <FormField
            labelName={t("news_theme.contact.label")}
            inputId="contactLabel"
            emptyErrorMessage={t("global.empty_error_field")}
            readOnly={!editMode}
            maxLength={FIELD_LENGTH.NAME}
          />
        </Col>
      </Row>
    </>
  );
};

NewsThemeContactFormSection.defaultProps = {
  editMode: true
};

export default NewsThemeContactFormSection;
